export const PATH_TO_STEP_ID: Record<string, string> = {
  '/validation': 'step1',
  '/personal': 'step2',
  '/residence': 'step3',
  '/finance': 'step4',
  '/job': 'step5',
  '/references': 'step6',
  '/confirm': 'step7',
  '/finish': 'step8',
};
